import { useDroppable } from "@dnd-kit/core";

interface Props {
  stageKey: string;
  title: string;
  count: number;
  children: React.ReactNode;
}

export function DroppableColumn({ stageKey, title, count, children }: Props) {
  const { setNodeRef, isOver } = useDroppable({ id: `col:${stageKey}` });
  return (
    <div
      ref={setNodeRef}
      className="col"
      style={{ borderColor: isOver ? "var(--accent)" : undefined }}
    >
      <div className="col-header">
        <span>
          <span className="stage-dot" style={{ background: `var(--${stageKey})` }} />
          {title}
        </span>
        <span className="badge">{count}</span>
      </div>
      {children}
    </div>
  );
}
